import { GEOFENCE_ACTIONS } from '@/_consts/GeofenceAction'


export default class GeofenceAction {
  public enter: any[]
  public exit: any[]

  constructor() {
    this.enter = [GEOFENCE_ACTIONS[0]]
    this.exit = [GEOFENCE_ACTIONS[0]]
  }
}
